module.exports = __webpack_public_path__ + "static/media/SoA_Design_Deployment_Tool_S.2539bec2.jpg";